import {subscribe, useInjection} from 'dna-react-ioc'

import {OnboardingStore} from './OnboardingStore'
import {ONBOARDING_STORE_SYMBOLS} from './symbols'

export const getOnboardingStore = () => {
    return subscribe<OnboardingStore>(ONBOARDING_STORE_SYMBOLS.OnboardingStore)
}

export const useOnboardingStore = () => {
    return useInjection<OnboardingStore>(ONBOARDING_STORE_SYMBOLS.OnboardingStore)
}
